import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const Updatemsilvesselreport = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onClickUpdateItem(props);
    };
    
   // if(props.data.msil_transit_delay == 1)
    //{
   //     var colr = 'redfont'
   // }
   // else{
       
            var colr = 'txt-secondary'
      
    //}
    return (
        <div>
            <button onClick={handleEventClick} className="btn btn-warning custom-btn f12" 
            title="Update" >Update</button>
            
        </div>
    );
};

export default Updatemsilvesselreport;
